<template>
  <v-file-input
      :id="control.uniqueId"
      :name="control.name || control.uniqueId"
      :accept="control.allowedExtension"
      outlined
      :placeholder="control.placeholderText"
      clearable
      v-model="fileModel"
      show-size
      truncate-length="30"
      :disabled="isDisabled"
      :rules="rulesLocal.maxSizeFile(control.maxSize)"
      @change="toBase64(fileModel)"

  >
    <template v-slot:selection="{ index, text }">
      <v-chip
          v-if="index < 2"
          color="deep-purple accent-4"
          dark
          label
          small
      >
        {{ text }}
      </v-chip>

      <span
          v-else-if="index === 2"
          class="overline grey--text text--darken-3 mx-2"
      >
        +{{ fileModel.length - 2 }} File(s)
      </span>
    </template>
    <template v-slot:append>
        <pdf-preview-dialog
          v-if="formFileID"
          style="margin: -8px!important;"
          :pdf-data-id="formFileID"
        />
    </template>
  </v-file-input>
</template>

<script>
import {BaseControlSkeleton} from 'v-form-builder';
import {commitAddNotification} from '@/store/main/mutations';
import {rules} from '@/utils';
import LZString from 'lz-string';
import {readUserProfile} from '@/store/main/getters';
import PdfPreviewDialog from "@/components/dialogs/PdfPreviewDialog.vue";

export default {
  name: 'FileUploadControl',
  components: {PdfPreviewDialog},
  extends: BaseControlSkeleton,
  data: () => ({
    fileModel: null,
    maxFileSize: 100,
    rulesLocal: rules,
    isDisabled: false,
    formFileID: 0,
  }),
  async mounted() {
    this.formFileID = this.value?.form_files_id
    this.maxFileSize = this.control.maxSize;

    if (this.control.disableByRoleSetting) {
      const userProfile = readUserProfile(this.$store);
      this.isDisabled =
          !(userProfile?.role?.settings?.permissions?.can_edit_control_field?.methods?.can_edit_control_field);
    } else if (this.control.isDisabled) {
      this.isDisabled = true;
    }

    // if (!this.value) {
    //   await Promise.all([
    //     await new Promise((resolve, reject) => setTimeout(() => resolve(), 500)),
    //     this.updateValue(this.value),
    //     this.fileModel = this.value || {},
    //   ]);
    // }
  },
  methods: {
    async toBase64(value) {

      let fileInfos = '';
      if (value instanceof Blob) {
        if (Number(this.control.maxSize) !== 0 && (value.size / 1024 / this.control.maxSize) > 1) {
          commitAddNotification(this.$store, {
            content: `O arquivo excedeu o limite máximo de ${this.control.maxSize}Kb.`,
            color: 'error',
          });
          this.fileModel = null;
          this.updateValue('');
          return;
        }

        if (value.type !== this.control.allowedExtension) {
          commitAddNotification(this.$store, {
            content: `Tipo inválido! são aceitos apenas arquivos no formato ${this.control.allowedExtension.split('/')[1]}`,
            color: 'error',
          });
          this.fileModel = null;
          this.updateValue('');
          return;
        }
        const converted = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(value);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });

        // @ts-ignore
        const compressed = LZString.compressToUTF16(converted).trim();

        /* tslint:disable:no-bitwise */
        fileInfos = {
          name: value.name, type: value.type, compressed_size: compressed.length,
          original_size: value.size, data_base64: compressed, form_files_id: this?.value?.form_files_id | 0,
        };
        /* tslint:disable:no-bitwise */
      }
      this.updateValue(fileInfos);
    },
  },
};
</script>

<style scoped>
</style>
